import * as DocumentPicker from "expo-document-picker";
import { File as ExpoFile } from "expo-file-system";
import * as PapaParse from "papaparse";
import React, { useCallback, useEffect, useState } from "react";
import { Image, View, Platform } from "react-native";
import AppActivityIndicator from "../../shared/AppActivityIndicator";
import { fetchGuests, inviteGuests } from "../../http/events";
import AppHeader from "../../shared/AppHeader";
import AppContent from "../../shared/AppContent";
import GuestListItem from "../../shared/GuestListItem";
import OnboardingButton from "../../shared/OnboardingButton";
import Container from "@/components/shared/AppContainer";
import Text from "@/components/shared/AppText";
import tw from "twrnc";
import { t } from "@/localization";

const GuestImport = ({ route, navigation }) => {
  const { slug } = route.params;
  const [guests, setguests] = useState([]);
  const [loading, setloading] = useState(true);
  const [event, setEvent] = useState({ slug });

  useEffect(() => {
    const fetchAsync = async () => {
      try {
        const myEvent = await fetchGuests(slug);
        setEvent(myEvent);
        setloading(false);
      } catch (err) {
        console.error(err);
      }
    };

    fetchAsync();
  }, [slug]);

  const selectDocument = useCallback(async () => {
    setloading(true);
    const res = await DocumentPicker.getDocumentAsync({
      // .csv Normal mime not working on android
      type: Platform.OS !== "web" ? "text/*" : "text/csv",
      multiple: false,
      copyToCacheDirectory: true,
    });
    if (res.canceled || !res.assets?.length) {
      setloading(false);
      return;
    }
    const { assets } = res;
    console.log(assets);
    const uri = assets[0]?.uri;

    // On web the data comes prefixed with => 'data:application/octet-stream;base64,' which need to be removed
    let content;
    if (Platform.OS === "web") {
      const file = assets[0]?.file;
      if (file) {
        // Modern expo-document-picker returns a File object on web
        content = await file.text();
      } else {
        // Fallback for older versions that return a data URI
        const base64Data = assets[0]?.base64 || uri;
        const base64Content = base64Data.split(",")[1];
        if (base64Data.startsWith("data:text/csv")) {
          content = decodeURIComponent(escape(window.atob(base64Content)));
        } else {
          content = atob(base64Content);
        }
      }
    } else {
      // The legacy readAsStringAsync export throws since Expo SDK 54.
      content = await new ExpoFile(uri).text();
    }

    PapaParse.parse(content, {
      header: true,
      encoding: "utf-8",
      dynamicTyping: true,
      skipEmptyLines: true,
      transformHeader: (header) => header.toLowerCase().replace(/[^a-z]/g, ""),
      error: (error, file) => {
        console.log(` error => ${error} file => ${file}`);
      },
      complete: ({ data }, file) => {
        console.log(data);
        const emails = data.map((g) => g.email);

        setguests([
          ...guests,
          ...data
            .map((guest) => {
              return {
                name:
                  guest.first_name || guest.last_name
                    ? `${guest.first_name} ${guest.last_name || ""}`
                    : guest.name,
                email: guest.email,
              };
            }) // Dedup and remove all without emails:
            .filter((g, pos) => {
              return !!g.email && emails.indexOf(g.email) === pos;
            }),
        ]);
      },
    });

    setloading(false);
  }, []);

  const deleteGuest = (i) => {
    setguests(guests.filter((e, index) => index !== i));
  };

  const inviteAll = async () => {
    try {
      setloading(true);
      await inviteGuests(event, guests);
      navigation.navigate("GuestList", { slug });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container>
      <AppHeader title={t("CSV Import")} hasRightButton={false} />
      <AppContent>
        {loading && <AppActivityIndicator />}
        {!loading && (
          <View style={tw`flex-1 flex-col`}>
            {!guests.length && (
              <View style={tw`mx-11`}>
                <Image
                  // resizeMode={"contain"}
                  source={require("../../../assets/guestImport.png")}
                  width="242"
                  height="207"
                  style={tw`w-[242px] h-[207px] my-[116px] self-center`}
                />
                <OnboardingButton
                  rounded
                  primary
                  block
                  style={tw`h-12 rounded-[5px]`}
                  onPress={selectDocument}
                  icon="document"
                  iconLeftColor="white"
                  text={t("Select File")}
                />

                {/* The column names stay English: they're what the file must use. */}
                <Text style={tw`text-center mt-2.5`}>
                  {t(
                    "Format: CSV. Required column: Email. Optional columns: Name, First Name, Last Name"
                  )}
                </Text>
              </View>
            )}
            {!!guests.length && (
              <>
                <View style={tw`flex-grow`}>
                  {guests.map((guest, i) => (
                    <GuestListItem
                      guest={guest}
                      key={guest.id || guest.email}
                      onDelete={() => deleteGuest(i)}
                    />
                  ))}
                </View>

                <OnboardingButton
                  onPress={inviteAll}
                  text={t("Invite All ({count})", { count: guests.length })}
                  style={tw`m-2.5`}
                />
              </>
            )}
          </View>
        )}
      </AppContent>
    </Container>
  );
};

export default GuestImport;
